import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { googleAuth, isGoogleSupportedPlatform, type GoogleBinding } from '@/services/googleAuth';
import GoogleAuthFlow from '../auth/components/GoogleAuthFlow';

export default function GoogleIdentityCard() {
  const { accessToken } = useAuth();
  const [binding, setBinding] = useState<GoogleBinding | null>(null);
  const [error, setError] = useState('');
  const [intent, setIntent] = useState<'bind' | 'unlink' | null>(null);
  const [confirm, setConfirm] = useState(false);
  const [email, setEmail] = useState('');
  const enabled = isGoogleSupportedPlatform();
  const refresh = useCallback(async () => {
    if (!accessToken || !enabled) return;
    setBinding(null); setError('');
    try { setBinding(await googleAuth.binding(accessToken)); }
    catch { setError('暂时无法获取 Google 绑定状态'); }
  }, [accessToken, enabled]);
  const closeFlow = () => { setIntent(null); setConfirm(false); setEmail(''); void refresh(); };
  useEffect(() => { void refresh(); }, [refresh]);
  if (!enabled) return null;
  return <section className="mb-4 rounded-2xl bg-white p-4 shadow-[0_2px_12px_rgba(0,0,0,0.06)]" aria-label="Google 登录管理">
    <h2 className="font-bold text-gray-900">Google 登录</h2>
    {error ? <><p role="alert" className="mt-2 text-sm text-red-600">{error}</p><button type="button" onClick={() => void refresh()} className="min-h-11 text-indigo-600">重试</button></> : !binding ? <p role="status" className="mt-3 text-gray-500">正在获取绑定状态…</p> : <>
      <p className="mt-2 text-sm text-gray-600">{binding.bound ? `已绑定 · ${binding.email_masked || 'Google 账号'}` : '未绑定'}</p>
      <button type="button" className="mt-2 min-h-11 text-indigo-600" onClick={() => binding.bound ? setConfirm(true) : setIntent('bind')}>{binding.bound ? '解除绑定' : '绑定 Google'}</button>
    </>}
    {confirm && <div className="mt-3 border-t pt-4">
      <p className="text-sm text-gray-600">解除后需使用邮箱验证码登录，现有账户及跟随关系将保留。请输入原账号邮箱进行验证。</p>
      <label htmlFor="google-unlink-email" className="mt-3 block text-sm">原账号邮箱</label>
      <input id="google-unlink-email" type="email" autoComplete="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} className="my-3 h-12 w-full rounded-xl border px-3" />
      <button type="button" disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())} onClick={() => setIntent('unlink')} className="min-h-11 text-red-600 disabled:text-gray-400">验证邮箱并解除</button>
      <button type="button" onClick={() => setConfirm(false)} className="ml-6 min-h-11 text-gray-600">取消</button>
    </div>}
    {intent && <GoogleAuthFlow intent={intent} email={intent === 'unlink' ? email.trim() : undefined} onClose={closeFlow} onSuccess={closeFlow} />}
  </section>;
}
